import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MetricsApiService } from '../core/http/MetricsApi.service';

const ENDPOINT = 'customer-profiles/customer-branding';

@Injectable()
export class ClientBrandingApiService extends MetricsApiService {
  get<TODO>(endpoint: string = ENDPOINT): Observable<TODO> {
    return super.get(endpoint);
  }
}
